<template>
        <div class="fts-dropdown" v-click-outside="closeDropdown">
            <div :class="['dropdown-control', openedDropdown ? 'straight-border' : '']" @click="openCloseDropdown">
                <span class="dropdown-title" v-if="selectedList.length == 0">{{dropdownTitle}}</span>
                <div v-else class="selected-list">
                    <div v-for="selected in selectedList" class="selected-item">
                        {{selected.value}}
                        <i class="fa fa-times-circle" @click.stop="selectOption(selected)"></i>
                    </div>
                </div>
                <i :class="['fa', openedDropdown ? 'fa-caret-up' : 'fa-caret-down']"></i>
            </div>
            <div :class="['dropdown-list', openedDropdown ? 'list-visible' : '']">
                <div class="dropdown-search">
                    <i class="fa fa-search"></i>
                    <input v-model="searchedPhrase" type="text" placeholder="Search" @keyup="searchPhrase"/>
                </div>
                <div class="dropdown-option" v-for="row in displayedValues">
                    <label class="dropdown-label" :for="'option' + row.value" :option-selected="row.selected">
                        <input class="dropdown-checkbox" :id="'option' + row.value" type="checkbox" :checked="row.selected" @change="selectOption(row)">
                        <span></span>
                        <span class="option-content">{{row.value}}</span>
                    </label>
                </div>
                <div class="clear-box">
                    <button class="btn btn-light clear-btn" @click="clearDropdown">Clear</button>
                </div>
            </div>
        </div>
</template>

<script>
    import Vue from 'vue';

    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                if (!(el == event.target || el.contains(event.target))) {
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });

    export default {
        name: "FTSdropdown",
        props: {
            title: String,
            options: Array,
            value: Array
        },
        data() {
            return {
                dropdownTitle: 'Select values',
                openedDropdown: false,
                searchedPhrase: '',
                dropdownValues: [],
                displayedValues: [],
                selectedList: []
            }
        },
        methods: {
            setPropsToData(){
                this.dropdownTitle = this.title;
                this.options.map(option => {
                    this.dropdownValues.push({value: option, selected: false});
                })
            },
            openCloseDropdown() {
                if (!this.openedDropdown)
                    this.openedDropdown = true;
                else
                    this.openedDropdown = false;
            },
            closeDropdown() {
                if (this.openedDropdown)
                    this.openedDropdown = false;
            },
            searchPhrase() {
                this.displayedValues = this.dropdownValues.filter(item => {
                    return item.value.indexOf(this.searchedPhrase) != -1 ? item : null;
                })
            },
            selectOption(option) {
                this.value = [];
                option.selected = !option.selected;
                if (option.selected)
                    this.selectedList.push(option);
                else
                    this.selectedList.splice(this.selectedList.indexOf(option),1);
                for ( let i = 0 ; i < this.selectedList.length ; i++){
                    this.value.push(this.selectedList[i].value);
                }
                this.$emit('input', this.value);
            },
            deselectOption(option) {
                this.selectedList.splice(this.selectedList.indexOf(option), 1);
                this.displayedValues[this.displayedValues.indexOf(option)].selected = false;
                for ( let i = 0 ; i < this.selectedList.length ; i++){
                    this.value.push(this.selectedList[i].value);
                }
                this.$emit('input', this.value);
            },
            clearDropdown() {
                this.displayedValues.map(item => {
                    item.selected = false;
                })
                this.selectedList = [];
                this.openedDropdown = false;
            }
        },
        mounted() {
            this.setPropsToData();
            this.displayedValues = this.dropdownValues;
        }
    }
</script>

<style lang="scss">

    .fts-dropdown {
        position: relative;
        display: inline-block;
        width: 300px;
        background-color: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        .dropdown-control {
            display: flex;
            height: 35px;
            justify-content: space-between;
            align-items: center;
            padding: 6px 16px;
            border: 1px solid #c9cfd4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            cursor: pointer;
            user-select: none;
            &.straight-border{
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            .dropdown-title {
                padding: 3px 0;
            }
            .selected-list {
                display: flex;
                justify-content: flex-start;
                flex-wrap: nowrap;
                flex-grow: 1;
                overflow: hidden;
                .selected-item {
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    padding: 3px 8px;
                    background-color: #bfe1ff;
                    border-radius: 5px;
                    margin-right: 6px;
                    i {
                        margin-left: 8px;
                    }
                }
            }
            .fa-caret-down,
            .fa-caret-up {
                padding-left: 10px;
            }
        }
        .dropdown-list {
            position: absolute;
            top: 35px;
            left: 0;
            display: none;
            width: 100%;
            background-color: #fff;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            &.list-visible {
                display: initial;
            }

            .dropdown-search {
                padding: 6px 18px;
                border: 1px solid #c9cfd4;
                border-top: none;
                input {
                    margin-left: 14px;
                    border: none;
                    &:focus {
                        outline: none;
                    }
                }
            }

            .dropdown-option {
                height: 35px;
                border-left:  1px solid #c9cfd4;
                border-right:  1px solid #c9cfd4;
                cursor: pointer;
                &:last-child {
                    border-bottom:  1px solid #c9cfd4;
                }
                &:hover {
                    background-color: #0088ff;
                    .option-content {
                        color: #ffffff;
                    }
                }
                .dropdown-label {
                    display: flex;
                    width: 100%;
                    height: 35px;
                    align-items: center;
                    margin-bottom: 0;
                    cursor: pointer;
                    &[option-selected="true"]{
                        background-color: #bfe1ff;
                        &:hover {
                            background-color: #0088ff;
                        }
                    }
                    .dropdown-checkbox {
                        display: none;
                        &+span {
                            margin: 0 16px;
                        }
                        & + span::before {
                            content: '\00A0';
                            font-size: 10px;
                            line-height: 12px;
                            text-align: center;
                            display: inline-block;
                            background-color: #f2f2f2;
                            font-family: "FontAwesome";
                            width: 16px;
                            height: 16px;
                            border: 1px solid #3a4149;
                            -webkit-border-radius: 2px;
                            -moz-border-radius: 2px;
                            border-radius: 2px;
                            margin-bottom: 4px;
                        }
                        &:checked + span::before {
                            content: '\f00c';
                        }
                    }
                    .option-content {
                        vertical-align: middle;
                        user-select: none;
                    }
                }
            }
            .clear-box {
                .clear-btn {
                    display: block;
                    width: 100%;
                    border: 1px solid #c9cfd4;
                    border-top: none;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                }
            }
        }
    }

    .dark-theme {


        .fts-dropdown {
            background-color: #515b65;
            .dropdown-control {
                border: 1px solid #1a1c1d;
                .selected-list {
                    .selected-item {
                        background-color: #0088ff;
                    }
                }
            }
            .dropdown-list {
                background-color: #515b65;

                .dropdown-search {
                    border: 1px solid #1a1c1d;
                    input {
                        background-color: #515b65;
                        color: #edeeef;
                        &::placeholder{
                            color: #edeeef;
                        }
                    }
                }

                .dropdown-option {
                    border-left:  1px solid #1a1c1d;
                    border-right:  1px solid #1a1c1d;
                    &:last-child {
                        border-bottom:  1px solid #1a1c1d;
                    }
                    &:hover {
                        background-color: #0088ff;
                        .option-content {
                            color: #edeeef;
                        }
                    }
                    .dropdown-label {
                        &[option-selected="true"]{
                            background-color: #3A4149;
                            &:hover {
                                background-color: #0088ff;
                            }
                        }
                        .dropdown-checkbox {
                            & + span::before {
                                background-color: #f2f2f2;
                                color: #1a1c1d;
                                border: 1px solid #1a1c1d;
                            }
                        }
                    }
                }
                .clear-box {
                    .clear-btn {
                        border: 1px solid #1a1c1d;
                        background-color: #2f353a;
                        color: #edeeef;
                    }
                }
            }
        }
    }

</style>
